class Nav {
  constructor() {
    this.toggleNav = $('#menu-toggle');
    this.navWrapper = $('.mobile-menu-container');
    this.allLinks = $('.nav-wrapper a');
    this.body = $('body');
    let that = this;
    this.isOpen = false;


    $(this.toggleNav).on('click tap', function (e) {
      console.log('click');
      $(this).toggleClass("hamburger--emphatic js-hamburger is-active");
      if (that.isOpen) {
        that.closeNav();
      } else {
        that.openNav();
      }
    });
  }

  openNav() {
    const that = this;
    that.isOpen = true;
    that.body.addClass('nav-open');
    that.toggleNav.attr('aria-expanded', true);
    //add transition on click to prevent side load animation
    that.navWrapper.addClass('mobile-menu-container__open');
  }

  closeNav() {
    const that = this;
    that.isOpen = false;
    that.body.removeClass('nav-open');
    that.toggleNav.attr('aria-expanded', false);
    //add transition on click to prevent side load animation
    that.navWrapper.removeClass('mobile-menu-container__open');
  }
}
